/**
 * Indicates whether the specified object is undefined or null or if the value
 * associated with the specified keyStack (path) is undefined or null.
 *
 * @param valueObject The object that we need to check.
 * @param keyStack An optional list of parameters that will be checked;
 *                 e.g. 'a.b' will test whether object[a][b] is null or undefined.
 */
export function isNil(valueObject: any, keyStack?: string): boolean {
  if (_isNil(valueObject)) {
    return true;
  }

  if (keyStack && keyStack !== '') {
    let value: any = valueObject;
    for (let key of keyStack.split('.')) {
      value = value[key];
      if (_isNil(value)) {
        return true;
      }
    }
  }

  return false;
}

/**
 * @internal
 */
export function _isNil(value: any): value is undefined | null {
  return value === undefined || value === null;
}
